import {hasAccessPermission} from '../common/permissions/validations';
import {scopes} from '../common/permissions/dictionary';

const parseValidWarehouses = (rawWarehouses, validWarehouses) => {
  if (rawWarehouses) {
    let warehouses = rawWarehouses.split(',');
    warehouses = warehouses.map((warehouse) => warehouse.trim().toUpperCase());

    return warehouses.filter(
      (warehouse) => validWarehouses.indexOf(warehouse) !== -1
    );
  }

  return [];
};

const parseValidPickingZone = (rawZone, validZones) => {
  if (rawZone) {
    const selectedZone = validZones.find(
      (zone) => zone.name === rawZone.trim().toUpperCase()
    );

    return selectedZone ? selectedZone.code : '';
  }

  return '';
};

const parseReservedLocations = (value) => {
  if (value) {
    const parsedValue = value.split(',');

    return parsedValue.map((item) => item.trim().toUpperCase());
  }

  return [];
};

const parseRawValue = (value) => {
  if (value) {
    return value.trim().toUpperCase();
  }

  return '';
};

export const parseWarehouses = (warehouses, permissions) => {
  const filteredWarehouses = warehouses.filter((item) =>
    hasAccessPermission(permissions, `Bodega ${item.code}`, scopes.Edit)
  );

  return filteredWarehouses;
};

export const parseFreeLocations = (freeLocations) => {
  return freeLocations.map((item) => ({'text': item, 'value': item}));
};

export const parseTransferDetail = (data, validWarehouses, validZones) => {
  return data.map((item) => ({
    'aisle': item[0],
    'module': item[1],
    'level': item[2],
    'sequential': item[3],
    'binType': item[4],
    'warehouses': parseValidWarehouses(item[5], validWarehouses),
    'pickingZone': parseValidPickingZone(item[6], validZones),
  }));
};

export const parseFileData = (data) => {
  return data.map((item) => ({
    'partCode': parseRawValue(item[0]),
    'newLocation': parseRawValue(item[1]),
    'reservedLocations': parseReservedLocations(item[2]),
  }));
};
